<template>
  <div class="search-index">
    <div class="top">
      <i class="icon-img icon-back" @click="goBack"></i>
      <div class="search-con">
        <i class="icon-img icon-search" @click="searchSure"></i>
        <input type="text"
               v-model="searchVal"
               placeholder="请输入关键字"
               @input="searchInput"
               @compositionstart="compositionstart"
               @compositionend="compositionend"
               @keyup.enter="searchSure"
               @click="focusVal">
        <i v-if="searchVal" class="icon-img icon-cuo-circle" @click="clearSearchVal"></i>
      </div>
      <template v-if="searchListBool&&searchLists&&searchLists.length">
        <div class="search-result">
          <div class="max-con">
            <template v-for="(item,searchIndex) in searchLists">
              <div class="search-result-list" @click="searchListClick(searchIndex)" :key="'searchLists'+searchIndex">
                <p class="oneRow" v-html="item.name"></p>
              </div>
            </template>
          </div>
        </div>
      </template>
      <span @click="searchSure">搜索</span>
    </div>
    <div class="search-content">
      <transition enter-active-class="animated fadeInDown" leave-active-class="animated slideOutUp">
        <div v-if="searchClickBOol&&!searchVal" class="search-sure-tips no-data-tips">请输入关键字</div>
      </transition>
      <template v-if="contentBool&&searchVal">
        <phone-address :address-type="addressType" :parameter="parameter"  @cityId="cityIdVal"></phone-address>
        <template v-if="currentOnlyLists&&currentOnlyLists.length">
          <div class="industry-list clearFloat clearFloat-2">
            <template v-for="(item,index) in currentOnlyLists">
              <only-list :item="item" :lazy="lazy" :class-name="'search-list'+index" :key="'industry-list'+index"></only-list>
            </template>
          </div>
        </template>
        <template v-else>
          <div class="marTop no-data-text animated bounceIn">
            <div class="no-data"></div>
            <p>抱歉，暂无<span v-if="searchVal"> {{searchVal}} </span>相关内容</p>
          </div>
        </template>
      </template>
      <template v-else>
        <div class="history-content">
          <template v-if="historyList&&historyList.length">
            <i class="icon-img icon-delete" @click="deleteFun"></i>
            <p-title :title="historyTitle"></p-title>
            <div class="history-list">
              <template v-for="(list,historyListIndex) in historyList">
                <a :href="'http://pano.szscmap.com/'+list.split('@')[0]+'/'" :key="'historyList'+historyListIndex">{{list.split('@')[1]}}</a>
              </template>
            </div>
          </template>
          <template v-else>
            <div class="phone-no-data">
              <img :src="$noData" alt="">
              <p>暂无历史搜索，快去找你喜欢的单位</p>
            </div>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import onlyList from '@/components/onlyList.vue'
import pTitle from '@/components/title.vue'
import phoneAddress from '@/components/Phone/address.vue'
export default {
  name: 'phoneSearch',
  props: [''],
  data () {
    return {
      searchVal: '',
      focusBool: false,
      searchListBool: false,
      oldSearchLists: [],
      searchLists: [],
      flag: true,
      addressType: 1,
      contentBool: false,
      parameter: {
        topIndex: -1,
        cityIndex: -1,
        countyIndex: -1
      },
      cityId: 0,
      lazy: {
        bool: false
      },
      total: 0,
      showLists: [],
      currentLists: [],
      currentOnlyLists: [],
      page: 1,
      limit: 8,
      historyTitle: {
        title: '历史搜索'
      },
      historyList: [],
      searchClickBOol: false
    }
  },
  components: {
    onlyList: onlyList,
    phoneAddress: phoneAddress,
    pTitle: pTitle
  },
  created () {
    let that = this
    let currentParams = JSON.parse(this.publicJs.decode(that.$route.query))
    that.cityId = currentParams.cityId || 0
    that.parameter.cityId = currentParams.cityId || 0
    that.parameter.topIndex = currentParams.topIndex
    that.parameter.cityIndex = currentParams.cityIndex
    that.parameter.countyIndex = currentParams.countyIndex
    that.searchVal = currentParams.keyWords
    if (that.searchVal) {
      that.contentBool = true
      that.httpData()
    }
    that.historyListData()
  },
  mounted () {
    this.listScrollb()
  },
  methods: {
    listScrollb: function () {
      let that = this
      that.$nextTick(function () {
        $('.search-index').scroll(function (e) {
          if (that.publicJs.isScrollBottom(this)) {
            // 滚动到底端了 加载内容
            // 加载数据
            // 滚动到底端了 加载内容
            // 加载数据
            let p = that.page
            if (that.currentList && that.currentList.length && p < that.currentList.length) {
              that.page++
            }
          }
        })
      })
    },
    focusVal: function () {
      this.focusBool = true
      this.searchListBool = true
    },
    compositionstart: function () {
      this.flag = false
    },
    compositionend: function () {
      this.flag = true
    },
    searchInput: function () {
      let that = this
      if (that.searchVal) {
        that.searchListBool = true
        if (that.flag) {
          that.httpData()
        }
      } else {
        that.searchLists = []
      }
    },
    httpData: function () {
      let that = this
      if (that.cityId >= 0) {
        that.httpAjax.getAjax('PanoWebService.asmx/GetPanoByWhere', {
          page: that.page,
          cityId: that.cityId,
          limit: 10000,
          typeId: 0,
          keyWords: that.searchVal
        }).then(function (data) {
          if (data.code === 1) {
            that.currentList = []
            that.currentOnlyLists = []
            let resData = JSON.parse(JSON.stringify(data.data))
            that.total = data.total
            that.oldSearchLists = resData
            that.searchLists = data.data.map(item => {
              let replaceReg = new RegExp(that.searchVal, 'g')// 匹配关键字正则
              let replaceString = '<span style="color:red;">' + that.searchVal + '</span>' // 高亮替换v-html值
              item.name = item.name.replace(replaceReg, replaceString) // 开始替换
              return item
            })
            let odlData = JSON.parse(JSON.stringify(that.searchLists))
            that.currentList = that.publicJs.newList(odlData, that.limit)
            that.currentListFun()
            that.page = 1
          }
        }, function (err) {
          console.log(err)
        })
      }
    },
    cityIdVal: function (val) {
      this.cityId = val
    },
    searchListClick: function (index) {
      let that = this
      let item = that.oldSearchLists[index]
      that.searchListBool = false
      that.publicJs.recordHist(item, 'hl')
      location.href = item.panoUrl
    },
    searchSure: function () {
      let that = this
      that.searchClickBOol = true
      if (that.searchVal) {
        that.contentBool = true
        that.searchListBool = false
        that.httpData()
      } else {
        setTimeout(function () {
          that.searchClickBOol = false
        }, 1500)
        // that.$message({msg: '请输入关键字'})
      }
    },
    clearSearchVal: function () {
      let that = this
      that.contentBool = false
      that.searchListBool = false
      that.searchVal = ''
      that.searchClickBOol = false
      that.searchLists = []
    },
    currentListFun: function () {
      let that = this
      if (that.currentList && that.currentList.length) {
        let bb = JSON.parse(JSON.stringify(that.currentList))
        that.currentOnlyLists = that.currentOnlyLists.concat(bb[that.page - 1])
      }
    },
    historyListData: function () {
      let that = this
      that.historyList = that.publicJs.initlocalStorage('hl')
    },
    deleteFun: function () {
      this.historyList = []
      this.publicJs.ClearnSerchHistry('hl')
    },
    goBack: function () {
      // this.$router.go(-1)
      this.$router.push({
        path: '/phoneIndex'
      })
    }
  },
  watch: {
    page: {
      handler: function (a, b) {
        let that = this
        if (a !== b) {
          that.page = a
          that.currentListFun()
        }
      },
      deep: true
    },
    cityId: {
      handler: function (a, b) {
        let that = this
        if (a !== b) {
          that.page = 1
          that.httpData()
        }
      },
      deep: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .top{
    position: fixed;
    left: 0;
    right: 0;
    color: white;
    padding: 8px 62.5px 8px 52.5px;
    background-color: #248DDF;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    font-size: 17px;
    font-weight: 500;
    z-index: 6;
  }
  .search-con{
    background: #FFFFFF;
    border-radius: 14px;
    width: 100%;
    height: 28px;
    position: relative;
    padding-left: 33px;
    padding-right: 15px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  .has-con{
    padding-left: 15px;
    padding-right: 33px;
    -webkit-transition: padding 0.5s;
    -moz-transition: padding 0.5s;
    -ms-transition: padding 0.5s ;
    -o-transition: padding 0.5s;
    transition: padding 0.5s;
  }
  .icon-cuo-circle{
    position: absolute;
    right: 10px;
    top:50%;
    margin-top: -6px;
  }
  .screen3 .icon-search{
    position: absolute;
    left: 10px;
    top:4px;
  }
  .top input::placeholder{
    color: #999999;
  }
  .top input{
    display: block;
    width: 100%;
    height: 100%;
    color: #333333;
    letter-spacing: 0;
  }
  .top>span{
    position: absolute;
    right: 12px;
    top:12px;
  }
  .search-content{
    padding: 50px 0;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    position: relative;
  }
  .no-data{
    height: 113px;
  }
  .history-content{
    padding: 11px;
    position: relative;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  .history-list{
    display: flex;
    display: -webkit-flex;
    flex-wrap: wrap;
    font-size: 12px;
    color: #333333;
  }
  .history-list>a{
    background-color: white;
    padding: 5px;
    border-radius: 2px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    margin-top: 10px;
    margin-right: 10px;
  }
  .icon-delete{
    position: absolute;
    right: 11px;
    top:11px;
    background-position: -337px -318px;
    z-index: 5;
  }
  .phone-no-data{
    max-width: 300px;
    margin-top: 5%;
  }
</style>



// WEBPACK FOOTER //
// src/Phone/search/index.vue